const enabled = (value) => value === true || String(value || "").trim().toLowerCase() === "true";

export function resolveAssistanceSurfaces({
  conciergeEnabled = false,
  helpHubEnabled = false,
  supportFloatingEnabled = false,
} = {}) {
  const aiEnabled = enabled(conciergeEnabled);
  const unifiedHubEnabled = aiEnabled && enabled(helpHubEnabled) && enabled(supportFloatingEnabled);

  return Object.freeze({
    conciergeEntryEnabled: unifiedHubEnabled,
    standaloneConciergeEnabled: aiEnabled && !unifiedHubEnabled,
  });
}

